<template>
    <div>

        <div style="height:350px; overflow-y:scroll;">
            <table id="tabla_detalle_planificacion_anual" class="table table-striped  w-100">

                <thead>
                    <th v-for="(item , index) in headers" :key="index" v-text="item"></th>
                </thead>

                <tbody>
                    <tr v-for="(fila, index_fila) in dataAux" :key="index_fila">
                        <template v-for="(data, index_item) in fila.data">
                            <td :key="index_item" class="text-center" v-if="index_item == 0">
                                <ui-checkbox color="primary" v-model="fila.data[index_item]" style="margin-top: 5px;" @change="checkFila($event, index_fila)"></ui-checkbox>
                            </td>

                            <td :key="index_item" v-else class="text-center">{{ data }}</td>
                        </template>
                    </tr>
                </tbody>

                 <tfoot>
                    <tr>
                        <td class="text-center pl-2"><b>Total carga</b></td>
                        <td colspan="3"></td>
                        <td class="text-center" v-for="(item, index) in totales" :key="index"><b v-text="item"></b></td>
                        <td class="text-center"><b v-text="totalPeriodo"></b></td>
                    </tr>
                </tfoot>
            </table>
        </div>

    </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';

    export default {
        props: ['data','totalPeriodo', 'headers','totales','id_tab'],

        computed : {
            ...mapState('lineas',["dataAnioSeleccionado","nuevosPlanificacionAnualMultiple","puertoParaEliminarPlanificacionAnual",
                                  "eliminacionTab1", "eliminacionTab2", "eliminacionTab3", "eliminacionTab4","checkPlanificacionAnual"])
        },

        data(){
            return {
                dataAux : [],
                acciones : [],
                dataMultipleSeleccionada : [],
                eliminacionDesdeEstecomponente: false,
                tab_id : this.id_tab,
                showTable : true
            }
        },

        methods : {

            ...mapActions('lineas', ["actionSetPuertosSeleccionadosPlanAnual","actionSetCheckPlanificacionAnual",
                                     "actionSetPuertoParaEliminarPlanificacionAnual",
                                     "actionSetEliminacionTab1","actionSetEliminacionTab2", "actionSetEliminacionTab3", 
                                     "actionSetEliminacionTab4"]),

            async generarBotonesAcciones(dataAux) {

                this.acciones = [];
                this.showTable = false;

                setTimeout(() => this.showTable = true, 100);

                await Object.keys(dataAux).map((_, index) => {

                    let {id, data} = dataAux[index];
                    let dataTemp = [false, ...data];

                    this.dataAux.push({
                        "id_puerto" : id,
                        "data" : dataTemp,
                        "acciones" : [
                            {
                                icon: "fa fa-times text-danger",
                                title: "Eliminar puerto",
                                id: index,
                            }
                        ]
                    });

                });

            },

            seleccionarAcciones(index, accion){

                switch (accion) {
                    case 'Eliminar puerto':
                        this.actionSetPuertoParaEliminarPlanificacionAnual(index);
                        this.eliminacionDesdeEstecomponente = true;
                        break;
                }
            },

            checkFila(event, index){

                let estado         = event;
                let check_filtrado = [];

                if (estado) {

                    let checkListTemp = [{id: index, data : this.dataAnioSeleccionado[index], checked: true} , ...this.checkPlanificacionAnual]

                    this.actionSetCheckPlanificacionAnual(checkListTemp);

                    // Cambia el estado del puerto seleccionado a true
                    this.actionSetPuertosSeleccionadosPlanAnual({id_tab: 1, estado: true});

                } else {

                    // Quita data de la fila seleccionada
                    this.checkPlanificacionAnual.filter((item) => item.id != index && check_filtrado.push(item));

                    this.actionSetCheckPlanificacionAnual(check_filtrado);

                    // Cambia el estado del puerto seleccionado a false
                    this.actionSetPuertosSeleccionadosPlanAnual({id_tab: 1, estado: 'x'});
                    
                }

            },

            eliminarFila(index){
                this.$delete(this.dataAux, index);
            }

        },
        watch : {

            data : function(_new){
                if(_new){
                    this.dataAux = [];
                    this.generarBotonesAcciones(_new);
                } 
            },

            nuevosPlanificacionAnualMultiple : function(_new){
                
                if (_new) {

                    const {index, pod, contenedores, productos} = _new;

                    this.dataAux.push({
                        "id_puerto" : 0,
                        "data" : [pod.name, contenedores.name, productos.name, 0,0,0,0,0,0,0,0,0,0,0,0,0,0],
                        "acciones" : [
                            {
                                icon: "fa fa-times text-danger",
                                title: "Eliminar planificación",
                                id: index,
                            },
                            {
                                icon: "fas fa-circle text-success",
                                title: "Puerto en lista para guardar",
                            }
                        ]
                    });

                }

            },

            puertoParaEliminarPlanificacionAnual : function(_new){

                this.eliminarFila(_new);

                this.id_tab == 1 && this.actionSetEliminacionTab1(true);
                this.id_tab == 2 && this.actionSetEliminacionTab2(true);
                this.id_tab == 3 && this.actionSetEliminacionTab3(true);
                this.id_tab == 4 && this.actionSetEliminacionTab4(true);
                
                if (this.eliminacionTab1, this.eliminacionTab2, this.eliminacionTab3, this.eliminacionTab4) {
                    this.actionSetPuertoParaEliminarPlanificacionAnual(-1);
                    this.actionSetEliminacionTab1(false);
                    this.actionSetEliminacionTab2(false);
                    this.actionSetEliminacionTab3(false);
                    this.actionSetEliminacionTab4(false);
                }

            },

            checkPlanificacionAnual : function(_new){

                this.dataAux.map( (_, index_data) => {

                    this.dataAux[index_data].data[0] = false;

                    _new.map((checked) => checked.id == index_data && (this.dataAux[index_data].data[0] = true));

                    let dataTemp = this.dataAux;
                    this.dataAux = [];
                    this.dataAux = dataTemp;

                });

            }

        }

    }
</script>

<style scoped>

    #tabla_detalle_planificacion_anual > thead > th{
        text-align: center;
    }

    table tfoot {
        position: sticky;
        bottom: 0;
        z-index: 1;
    }

    table tfoot td {
        padding: 15px 0;
        background: #bfbfbf;
    }

    table tr th:first-child {
        position: sticky;
        inset-inline-start: 0; /* "left" */
    }

</style>